import { ColorPicker } from 'product-card/components/shared/ProductColor/ColorPicker/ColorPicker'
import { ColorSheetButton } from 'product-card/components/shared/ProductColor/ColorSheetButton'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

export function ColorPickerContainer({
	className,
}: {
	readonly className?: string
}) {
	const { productColors } = useProductCard()
	const showAsFeatured = useShowAsFeatured()
	const { isLargeOrGreater } = useResponsive()

	return isLargeOrGreater ? (
		<ColorPicker
			className={className}
			showAsFeatured={showAsFeatured}
			productColors={productColors}
		/>
	) : (
		<ColorSheetButton productColors={productColors} />
	)
}
